import * as React from "react"
import useRouter from "@digits-shared/hooks/useRouter"
import { PASSWORD_RESET_RECIPIENT } from "src/frontend/components/Session/Glow/PasswordReset/locationState"
import { useCreatePasswordResetWithDelay } from "src/frontend/components/Session/Glow/PasswordReset/useCreatePasswordReset"
import { useGoToLogin } from "src/frontend/components/Session/Glow/PasswordReset/useGoToLogin"
import { Email, EmailNotification } from "src/frontend/components/Shared/Glow/EmailNotification"

export const ResetPasswordSent: React.FC = () => {
  const { location } = useRouter()
  const emailAddress = location.state[PASSWORD_RESET_RECIPIENT]

  const { loading, onClick, disabled } = useCreatePasswordResetWithDelay(emailAddress)
  const onBack = useGoToLogin()

  return (
    <EmailNotification onBack={onBack} onClick={onClick} disabled={disabled || loading}>
      If there is an account associated with <Email>{emailAddress}</Email>, you will receive an
      email with a link to reset your password.
    </EmailNotification>
  )
}
